import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../utils/useTranslation';
import { Button } from '../input/Button';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';

export const CollectionEmpty = () => {
    const t = useTranslation();

    return (
        <Flex px={4} height="100%" justifyContent="center">
            <Typography variant="title1" weight="heavy" pb={3}>
                {t('В коллекции пока ничего нет, но вы можете найти интересное в ленте')}
            </Typography>
            <Button size="xl" as={Link} to="/">
                {t('Перейти в ленту')}
            </Button>
        </Flex>
    );
};
